import React,{useRef,useEffect,useState} from 'react'
import Modal from 'react-bootstrap/Modal';
import ReactPlayer from 'react-player';
import * as constants from "../../../../Constants";
import { updateMeditationTime } from '../../../../services/Achievement';
import { favouriteUnFavouriteMark } from '../../../../services/Favourites';
import { useNavigate,Link } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { getKeyValueStrings } from '../../../../services/Library';
import { Oval } from 'react-loader-spinner'

//Component Description - Content Player modal for playing audio/video content, handling player actions, favourite and unfavourite
export default function VideoCard({content,handleContentData,detailModal,handleContentDetail,timerModal,handleTimerModal,videoModal,handleVideoModal,handleCompletionModal,isJourney,openSocialShare, handleSocialShare,setsubscriptionSource,handleIsLibraryjourney,isUserSubscribe,openMiniPlayer,handleMiniPlayer}) {
  const [playbtn,setPlaybtn] = useState(<i className="fas fa-play"></i>);
  const [totalTime,setTotalTime] = useState('00:00');
  const [playedTime,setplayedTime] = useState('00:00');
  const [progressBar,setprogressBar] = useState('0%');
  const [volume,setVolume] = useState('100%');
  const [vidVolume,setVidVolume] = useState(1);
  const [playing, setPlaying] = useState(true);
  const [add_to_fav,added_to_fav]=useState('');
  const [favourite,markFavourite]=useState(0);
  const [isMute,setIsMute]=useState(false);
  const [triviaText,setTriviaText]=useState("");
  const [displayLoader,setdisplayLoader] = useState(true);
  const [genericDesc,setGenericDesc]=useState('');
  const [style, setStyle] = useState({visibility: 'visible'});

  let consumedTime;
  if(content.streaming_stats && content.streaming_stats.consumed_time > 0 && content.streaming_stats.consumed_time !== content.streaming_stats.total_time && content.engagement.is_viewed ===0){
      consumedTime = content.streaming_stats.consumed_time;
  }else if(content.playedTime > 0 ){
    consumedTime = content.playedTime;
  }
  let navigate = useNavigate();
  let media_url;
  let poster_url = "";
  let media_type = "";
  let hours = "";
  let minutes = "";
  let seconds = "";
  let totalDuration = "";
  let currentTime = "";
  let currentProgress = "";
  let contentType;
  if(content.content_type==="news" && content.entities.news_articles[0].media_url!==null){
    contentType = content.entities.news_articles[0].media_type;
    media_url = content.entities.news_articles[0].media_url;
    if(contentType==="audio"){
      poster_url = content.entities.news_articles[0].media_thumb_url;
      media_type = "audio/mp3";
    }else{
      media_type = "video/mp4";
    }
  }else if(content.content_type==="audio"){
    contentType ="audio";
    media_url=content.entities.audio.media_url[0].url;
    poster_url = content.entities.audio.thumb_image[0];
  }else if(content.content_type==="video"){
    contentType ="video";
    poster_url = content.entities.video.thumb_image[0]
    media_url = content.entities.video.media_url[0].streaming_url.hls;
    media_type = "video/mp4";
  }else{
    contentType ="audio";
    poster_url = content.entities.image.thumb_image[0];
    media_url = content.metadata.attachment;
    media_type = "audio/mp3";
  }
  
  const vidRef = useRef();
  const reactPlayerRef = useRef();
  var x;
  var y;
  useEffect(() => {
    let keyPayload = {
      superStoreId    : constants.SUPER_STORE_ID,
      locale          : constants.LOCALE
    }
    getKeyValueStrings(keyPayload).then(result=>{
      //if content data doesnt have any description then set a default description
      setGenericDesc(result.data.Meditation_Generic_Desc);
    })
    setTriviaText(content.triviaText);
    if(content.engagement.is_favourite==="1" || content.engagement.is_favourite===1){
        added_to_fav("added_to_fav");
        markFavourite(1);
    }else{
        added_to_fav("");
        markFavourite(0);
    }
    if(contentType==="audio"){
      setTimeout(function(){
        if(vidRef.current !== null){
          if(content.isPaused !== true){
            vidRef.current.play()
          }
          if(consumedTime > 0){
            vidRef.current.currentTime = consumedTime;
          }
          if(vidRef.current.paused===false){
            setPlaybtn(<i className="fas fa-pause"></i>); 
          }else{
            setPlaybtn(<i className="fas fa-play"></i>); 
          }
          window.$("#volume-progress").slider("option", "value", '100');
        }
      },150);

      //progressbar seek
      window.$("#slider").slider({
        min: 0,
        max: 100,
        step: 1,
        slide: showValue
      });

      function showValue(event, ui) {
        if(vidRef.current.currentTime !== null){
          vidRef.current.currentTime = (ui.value/100)*vidRef.current.duration;
        }
      }
      //volume seek
      window.$("#volume-progress").slider({
        min: 0,
        max: 100,
        step: 1,
        slide: changeVolume
      });

      function changeVolume(event, ui) {
        if(vidRef.current.volume !== null){
          vidRef.current.volume = (ui.value/100).toFixed(1);
          var vol= ui.value+ "%"
          setVolume(vol)
        }
      }

      
      x = setInterval(function() {
        if(vidRef.current !== null){
          if(playing===false){
            vidRef.current.play();
            setPlaying(true);
          }
          if(vidRef.current.paused===true && vidRef.current.currentTime > 0){
            setPlaying(false)
            setPlaybtn (<i className="fas fa-play"></i>);
          }else{
            setPlaying(true)
            setPlaybtn (<i className="fas fa-pause"></i>);
          }
          hours = Math.floor(vidRef.current.currentTime / 3600);
          minutes = Math.floor((vidRef.current.currentTime - hours * 3600) / 60);
          seconds = Math.floor(vidRef.current.currentTime - (hours * 3600 + minutes * 60));
          if(hours < 10){ hours= "0" + hours }
          if(minutes < 10){ minutes= "0" + minutes }
          if(seconds < 10){ seconds= "0" + seconds }
          currentTime = hours > 0 ? hours +":"+minutes +":"+seconds : minutes +":"+seconds;
          setplayedTime(currentTime);
          if(vidRef.current.currentTime > 0 && vidRef.current.duration > 0){
            setdisplayLoader(false)
          }
          currentProgress = ((vidRef.current.currentTime/vidRef.current.duration)*100).toFixed(2) + "%";
          window.$("#slider").slider("option", "value", ((vidRef.current.currentTime/vidRef.current.duration)*100).toFixed(2) );
          setprogressBar(currentProgress)
          if (vidRef.current.ended===true) {
            clearInterval(x);
            updateContentTime();
            if(content.favouriteContentType==="meditations"){
              handleCompletionModal(true);
            }
            if(detailModal===true){
              handleContentDetail(false);
            }
            handleVideoModal(false);
          }
        }
        if(totalTime==='00:00' && vidRef.current !== null){
          hours = Math.floor(vidRef.current.duration / 3600);
          minutes = Math.floor((vidRef.current.duration - hours * 3600) / 60);
          seconds = Math.floor(vidRef.current.duration - (hours * 3600 + minutes * 60));
          if(hours < 10){ hours= "0" + hours }
          if(minutes < 10){ minutes= "0" + minutes }
          if(seconds < 10){ seconds= "0" + seconds }
          totalDuration = hours > 0 ? hours +":"+minutes +":"+seconds : minutes +":"+seconds;
          setTotalTime(totalDuration);
        }
        
      },200)
    }else{
      setTimeout(function(){
        setStyle({visibility: 'hidden'})
      },3000);
      setTimeout(function(){
        setPlaybtn(<i className="fas fa-pause"></i>);
        if(consumedTime > 0){
          reactPlayerRef.current.seekTo(consumedTime, "seconds");
        }
        window.$("#volume-progress").slider("option", "value", '100');
        window.$(".add-loading-text").html("<span class='loading-text'>Loading...</span>")
      },150);

      //progressbar seek
      window.$("#slider").slider({
        min: 0,
        max: 100,
        step: 1,
        slide: showValue
      });

      function showValue(event, ui) {
        if(reactPlayerRef.current.getCurrentTime() !== null){
          reactPlayerRef.current.seekTo((ui.value/100)*reactPlayerRef.current.getDuration(), "seconds");
        }
      }
      //volume seek
      window.$("#volume-progress").slider({
        min: 0,
        max: 100,
        step: 1,
        slide: changeVolume
      });

      function changeVolume(event, ui) {
          setVidVolume((ui.value/100).toFixed(1));
          var vol= ui.value+ "%"
          setVolume(vol)
      }
      
      y = setInterval(function() {
        window.addEventListener("visibilitychange", function() {
          if(playing){
            setPlaying(false)
            setPlaybtn (<i className="fas fa-play"></i>);
          }
        });
        
        if(totalTime==='00:00'  && reactPlayerRef.current !== null){
          if(reactPlayerRef.current.player.isPlaying===false && reactPlayerRef.current.getDuration() > 0){
            setPlaying(false)
            setPlaybtn (<i className="fas fa-play"></i>);
          }else{
            setPlaying(true)
            setPlaybtn (<i className="fas fa-pause"></i>);
          }
          hours = Math.floor(reactPlayerRef.current.getDuration() / 3600);
          minutes = Math.floor((reactPlayerRef.current.getDuration() - hours * 3600) / 60);
          seconds = Math.floor(reactPlayerRef.current.getDuration() - (hours * 3600 + minutes * 60));
          if(hours < 10){ hours= "0" + hours }
          if(minutes < 10){ minutes= "0" + minutes }
          if(seconds < 10){ seconds= "0" + seconds }
          totalDuration = hours > 0 ? hours +":"+minutes +":"+seconds : minutes +":"+seconds;
          setTotalTime(totalDuration);
          if(reactPlayerRef.current.getDuration() > 0){
            setdisplayLoader(false)
          }
        }
        if(reactPlayerRef.current !== null){
          hours = Math.floor(reactPlayerRef.current.getCurrentTime() / 3600);
          minutes = Math.floor((reactPlayerRef.current.getCurrentTime() - hours * 3600) / 60);
          seconds = Math.floor(reactPlayerRef.current.getCurrentTime() - (hours * 3600 + minutes * 60));
          if(hours < 10){ hours= "0" + hours }
          if(minutes < 10){ minutes= "0" + minutes }
          if(seconds < 10){ seconds= "0" + seconds }
          currentTime = hours > 0 ? hours +":"+minutes +":"+seconds : minutes +":"+seconds;
          setplayedTime(currentTime);
          currentProgress = ((reactPlayerRef.current.getCurrentTime()/reactPlayerRef.current.getDuration())*100).toFixed(2) + "%";
          window.$("#slider").slider("option", "value", ((reactPlayerRef.current.getCurrentTime()/reactPlayerRef.current.getDuration())*100).toFixed(2) );
          setprogressBar(currentProgress)
          if ((reactPlayerRef.current.getCurrentTime()===reactPlayerRef.current.getDuration()) && reactPlayerRef.current.getDuration()!==null) {
            clearInterval(y);
            updateContentTime();
            if(detailModal===true){
              handleContentDetail(false);
            }
            handleVideoModal(false); 
          }
        }else{
          clearInterval(y);
        }
      },200)
    }
    return () => {
      setPlaying(true);
      clearInterval(x);
      clearInterval(y);
    }
  }, [media_url,content])

  const updateContentTime=()=>{
    let payload = {
        userCode : localStorage.getItem('userCode'),
        superStoreId : content.super_store_id,
        IncreaseVideoView : "1",
        meditationTime : (contentType==="audio") ? vidRef.current.currentTime : reactPlayerRef.current.getCurrentTime() ,
        consumedTime : (contentType==="audio") ? vidRef.current.currentTime : reactPlayerRef.current.getCurrentTime(),
        activityType : "daily_journey",
        contentId: content.id,
        meditationViewDate:constants.SYSTEM_DATETIME,
        publishDate:content.live_date ? content.live_date : content.schedule_date,
        totalTime:(contentType==="audio") ? vidRef.current.duration : reactPlayerRef.current.getDuration(),
        contentType:content.content_type,
        locale : constants.LOCALE
    }
    updateMeditationTime(payload).then(response=>{
      // console.log(response);
      //response not essential only played time need to be updated
    })
  }

  const handlePlayVideo = (e) => {
    e.preventDefault();
    if(contentType==="audio"){
      if(vidRef.current.paused===true){
        vidRef.current.play();
        setPlaybtn(<i className="fas fa-pause"></i>);
        vidRef.current.play().catch((e)=>{
          /* error handler */
          confirmAlert({
              // title: 'Confirm to submit',
              message: 'Still Media not playing, Reload Page?',
              buttons: [
                  {
                      label: 'Yes',
                      onClick: () => refreshPage()
                  }
              ],
              overlayClassName:"zindex9999"
          });
        })
      }else{
        vidRef.current.pause();
        setPlaybtn (<i className="fas fa-play"></i>);
      }
    }else{
      if(playing){
        setPlaying(false)
        setPlaybtn(<i className="fas fa-play"></i>);
      }else{
        setPlaying(true)
        setPlaybtn(<i className="fas fa-pause"></i>);
      }
    }
  }

  const closeModal = () =>{  
    updateContentTime();
    if(contentType==="audio"){
      clearInterval(x);
    }else{
      clearInterval(y);
    }
    if(detailModal===true){
      handleContentDetail(false);
    }
    handleVideoModal(false);
  }

  const goBackward = (e) =>{
    e.preventDefault();
    if(contentType==="audio"){
      vidRef.current.currentTime = vidRef.current.currentTime - 10;
    }else{
      reactPlayerRef.current.seekTo(reactPlayerRef.current.getCurrentTime() - 10, "seconds");
    }
  }
  
  const goForward = (e) =>{
    e.preventDefault();
    if(contentType==="audio"){
      vidRef.current.currentTime = vidRef.current.currentTime + 10;
    }else{
      reactPlayerRef.current.seekTo(reactPlayerRef.current.getCurrentTime() + 10, "seconds");
    }
  }

  window.onkeydown = function(e) {
    //keyboard key press action on left/right arrow and space key
    if(handleVideoModal===true){
      switch (e.keyCode) {
          case 37:
            goBackward(e);
              // alert('left');
            break;
          case 39:
            goForward(e);
              // alert('right');
            break;
          case 32:
            handlePlayVideo(e);
              // alert('right');
            break;    
      }
    }
  };

  const toggleMute = (e) =>{
    e.preventDefault();
    if(contentType==="audio"){
      if(isMute===false){
        setIsMute(true);
        vidRef.current.muted = true;
      }else{
        setIsMute(false);
        vidRef.current.muted = false;
      }
    }else{
      if(isMute===false){
        setIsMute(true);
      }else{
        setIsMute(false);
      }
    }
  }


  const favouriteToggle = (e) => {
    e.preventDefault();

    if(isUserSubscribe === false){
      updateContentTime();
      if(contentType==="audio"){
        clearInterval(x);
      }else{
        clearInterval(y);
      }
      if(detailModal===true){
        handleContentDetail(false);
      }
      handleVideoModal(false);
      setsubscriptionSource(content.page);
      navigate(`/dashboard/manage_subscription`);
      return true;
    }

    var favouriteContentType=content.favouriteContentType ;

    let data = {
        userCode : localStorage.getItem('userCode'),
        superStoreId : content.super_store_id,
        storeId  : content.store_id,
        pageId   : content.page_id,
        portletId : content.portlet_id,
        contentId: content.id,
        markFavourite : (favourite===0) ? 1:0,
        favouriteContentType : favouriteContentType,
        locale : constants.LOCALE
    }

    if(data.markFavourite === 0){
        confirmAlert({
            // title: 'Confirm to submit',
            message: 'Do you want remove this from favourite list?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => FavouriteUnfavourite(data)
                },
                {
                    label: 'No',
                }
            ],
            overlayClassName:"zindex9999"
        });
    }else{
        FavouriteUnfavourite(data);
    }
  };

  function FavouriteUnfavourite(payload){
      favouriteUnFavouriteMark(payload).then(response => {
          if(response.code === 200){
              if (add_to_fav!=="") {
                  added_to_fav("");
                  handleIsLibraryjourney(true);
              } else {
                  added_to_fav("added_to_fav");
                  handleIsLibraryjourney(true);
              }

              if(favourite!==0){
                  window.$("#favbox").fadeOut();
                  window.$("#unfavbox").fadeIn();
                  markFavourite(0);

                  setTimeout(function(){
                      window.$("#unfavbox").fadeOut();
                  },5000);
              }else{
                  window.$("#unfavbox").fadeOut();
                  window.$("#favbox").fadeIn();
                  markFavourite(1);

                  setTimeout(function(){
                      window.$("#favbox").fadeOut();
                  },5000);
              }
          }else{
              window.$("#unfavbox").fadeOut();
              window.$("#favbox").fadeOut();
              window.$("#error-message").fadeIn();
              window.$("#errortitle").html('');
              window.$("#errordesc").html(response.message);
              setTimeout(function(){
                  window.$("#error-message").fadeOut();
              },5000);
          }
      });
  }

  const shareToggle = (e) =>{
    e.preventDefault();
    handleSocialShare(true);
  }

  const refreshPage = () =>{
		window.location.reload(); 
	}

  const toggleMiniplayer = (e) =>{
    e.preventDefault();
    content.playedTime = vidRef.current.currentTime;
    content.engagement.is_favourite = favourite;
    content.isPaused=vidRef.current.paused;
    handleContentData(content);
    handleMiniPlayer(true);
    handleVideoModal(false)
  }
  //handle view details(content description)
  var isExpanded;
  if(!window.$("#viewdetails").hasClass('show')){
      isExpanded=false;
  }
  else {
      isExpanded=true;
  }
  return (
    <>
    {
			 displayLoader === true  ?
			<Oval
				height={80}
				width={80}
				color="#ff7259"
				wrapperStyle={{}}
				wrapperClass="processing-loader"
				visible={true}
				ariaLabel='oval-loading'
				secondaryColor="#ff7259"
				strokeWidth={2}
				strokeWidthSecondary={2}
			/>
			:""
			}
    <Modal
    show={videoModal}
    onHide={() => closeModal()}
    id="player-main-scrn" 
    dialogClassName=" modal-fullscreen"
    contentClassName="height-100pc"
     tabIndex="-1" 
     aria-labelledby="video-popups" 
     aria-hidden="true"
    >
        <button type="button" className="btn-close video-close" data-bs-dismiss="modal" onClick={() => closeModal()} aria-label="Close"></button>
        <div className="modal-body p-0">
          {triviaText && isJourney===true && contentType==="audio" ? <p className='affirmationTriviatext'>{triviaText}</p> : ""}
          {contentType==='audio'?
          <video width="100%" ref={vidRef}  height="100%" poster={poster_url} disablePictureInPicture={true} >
            <source src={media_url} type={media_type}/>
          </video>
          :
          <ReactPlayer ref={reactPlayerRef} className='react-player'  pip={false} playing={playing} url={media_url} volume={vidVolume} muted={isMute}/>
          }
          <div className="player-main-screen">
            <div className="player-control-wrap"
              onMouseEnter={e => {
                  setStyle({visibility: 'visible'});
              }}
              onMouseLeave={e => {
                if(contentType!=='audio'){
                  setStyle({visibility: 'hidden'})
                }   
              }}
            >
              <div className="control-wrap" style={style} >
                <div className="video-title position-relative ps-2">
                
                  <a className="aerrowdown" data-bs-toggle="collapse" href="#viewdetails" role="button" aria-expanded="false" aria-controls="viewdetails">
                    {
                      isExpanded ?
                      <i className="fas fa-angle-down"></i>
                      :
                      <i className="fas fa-angle-up"></i>
                    }
                    
                  </a>
                  <ul className="list-unstyled mb-3">
                    <li className="list-inline-item">{content.content_title}</li>
                    {content.metadata.singer && content.metadata.singer[0] ? <li className="list-inline-item">{content.metadata.singer[0]}</li> : ''} 
                  </ul>
                </div>
                
                <div className="collapse" id="viewdetails">
                  <div className="card card-body pt-0">
                  <p dangerouslySetInnerHTML={{__html: content.metadata.custom_four ? content.metadata.custom_four : genericDesc}}/>
                  </div>
                </div>
                
                <div className="row mx-auto">
                  <div className="col-9">
                    <div className="player-time mb-3">
                      <span>{playedTime}/{totalTime !=="NaN:NaN" ? totalTime : "00:00"}</span>
                    </div>
                    <p id='val'></p>
                    <div className="progress mb-3" id='slider' style={{"cursor": "pointer"}}>
                      <div className="progress-bar"  style={{"width":progressBar}} role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <div className="volume-wrap">
                      <div className="d-flex justify-content-start">
                        <Link to="" onClick={(e)=>toggleMute(e)}>
                        {isMute === false ?
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32"><path fill="none" d="M0 0h24v24H0z"/><path d="M10 7.22L6.603 10H3v4h3.603L10 16.78V7.22zM5.889 16H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .817.387v15.89a.5.5 0 0 1-.817.387L5.89 16zm13.517 4.134l-1.416-1.416A8.978 8.978 0 0 0 21 12a8.982 8.982 0 0 0-3.304-6.968l1.42-1.42A10.976 10.976 0 0 1 23 12c0 3.223-1.386 6.122-3.594 8.134zm-3.543-3.543l-1.422-1.422A3.993 3.993 0 0 0 16 12c0-1.43-.75-2.685-1.88-3.392l1.439-1.439A5.991 5.991 0 0 1 18 12c0 1.842-.83 3.49-2.137 4.591z" fill="rgba(255,255,255,1)"/></svg> :
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32"><path fill="none" d="M0 0h24v24H0z"/><path d="M10 7.22L6.603 10H3v4h3.603L10 16.78V7.22zM5.889 16H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .817.387v15.89a.5.5 0 0 1-.817.387L5.89 16zm14.525-4l3.536 3.536-1.414 1.414L19 13.414l-3.536 3.536-1.414-1.414L17.586 12 14.05 8.464l1.414-1.414L19 10.586l3.536-3.536 1.414 1.414L20.414 12z" fill="rgba(255,255,255,1)"/></svg>
                        }
                        </Link>
       
                          <div className="volume-control">
                            <div className="progress ms-2" id='volume-progress'>
                              <div className="progress-bar" style={{"width":volume}} role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </div>
                      </div>
                      <div className="mt-3 text-end">
                      
                        <a className="view-details-btn" data-bs-toggle="collapse" href="#viewdetails" role="button" aria-expanded="false" aria-controls="viewdetails">
                          {
                            isExpanded ?
                              "Hide details"
                            :
                              "View details"
                          }
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="player-tools">
                      <div className="d-flex justify-content-end">
                        <Link to="" title='Share Thinkrightme' onClick={(e)=>shareToggle(e)} className="full-screen-btn me-3">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M13.12 17.023l-4.199-2.29a4 4 0 1 1 0-5.465l4.2-2.29a4 4 0 1 1 .959 1.755l-4.2 2.29a4.008 4.008 0 0 1 0 1.954l4.199 2.29a4 4 0 1 1-.959 1.755zM6 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm11-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" fill="rgba(255,255,255,1)"/></svg>
                        </Link>
                          {
                            content.favouriteContentType==="music"
                            ?
                              <Link to="" title='Go to Mini Player' onClick={(e)=>toggleMiniplayer(e)} className="full-screen-btn me-3">
                                <img src="https://img.icons8.com/ios-filled/24/ffffff/compress.png"/>
                              </Link>
                            :""
                          }
                        
                        {isJourney===false ?
                        <Link to="" onClick={(e)=>favouriteToggle(e)} className="like-btn">
                          <i className={`fas fa-heart ${add_to_fav}`}></i>
                        </Link> : '' }
                        
                      </div>
                    </div>
                    <div className="d-flex justify-content-between mt-3">
                      <Link to="" className="align-self-center" onClick={(e)=>goBackward(e)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none" style={{"color":"red"}}>
                          <path d="M12.1417 14.5833H27.0833C30.3985 14.5833 33.578 15.9003 35.9222 18.2445C38.2664 20.5887 39.5833 23.7681 39.5833 27.0833C39.5833 30.3985 38.2664 33.578 35.9222 35.9222C33.578 38.2664 30.3985 39.5833 27.0833 39.5833H8.33333V43.75H27.0833C31.5036 43.75 35.7428 41.9941 38.8684 38.8684C41.9941 35.7428 43.75 31.5036 43.75 27.0833C43.75 22.6631 41.9941 18.4238 38.8684 15.2982C35.7428 12.1726 31.5036 10.4167 27.0833 10.4167H12.1417L17.425 5.13333L14.4792 2.1875L4.16666 12.5L14.4792 22.8125L17.425 19.8667L12.1417 14.5833Z" fill="white"/>
                          <path d="M23.012 30.752C23.492 30.752 23.732 30.956 23.732 31.364C23.732 31.788 23.492 32 23.012 32H18.956C18.468 32 18.224 31.788 18.224 31.364C18.224 30.956 18.468 30.752 18.956 30.752H20.204V25.28L19.052 25.988C18.94 26.052 18.84 26.084 18.752 26.084C18.584 26.084 18.44 26.012 18.32 25.868C18.208 25.724 18.152 25.564 18.152 25.388C18.152 25.156 18.256 24.976 18.464 24.848L20.324 23.696C20.564 23.552 20.792 23.48 21.008 23.48C21.232 23.48 21.412 23.548 21.548 23.684C21.684 23.82 21.752 24.008 21.752 24.248V30.752H23.012ZM27.7953 32.108C26.7953 32.108 26.0313 31.74 25.5033 31.004C24.9753 30.26 24.7113 29.18 24.7113 27.764C24.7113 26.356 24.9753 25.284 25.5033 24.548C26.0313 23.804 26.7953 23.432 27.7953 23.432C28.7953 23.432 29.5593 23.804 30.0873 24.548C30.6153 25.284 30.8793 26.356 30.8793 27.764C30.8793 29.172 30.6153 30.248 30.0873 30.992C29.5593 31.736 28.7953 32.108 27.7953 32.108ZM27.7953 30.896C28.3393 30.896 28.7353 30.648 28.9833 30.152C29.2313 29.648 29.3553 28.852 29.3553 27.764C29.3553 26.668 29.2313 25.876 28.9833 25.388C28.7353 24.892 28.3393 24.644 27.7953 24.644C27.2513 24.644 26.8553 24.892 26.6073 25.388C26.3593 25.884 26.2353 26.676 26.2353 27.764C26.2353 28.852 26.3593 29.648 26.6073 30.152C26.8553 30.648 27.2513 30.896 27.7953 30.896Z" fill="white"/>
                          </svg>
                      </Link>
                      <Link to="" className="player-btn round-btn-play mx-auto end-pop" onClick={(e)=>handlePlayVideo(e)}>{playbtn}</Link>
                      <Link to="" className="align-self-center" onClick={(e)=>goForward(e)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none" style={{"color":"red"}}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
                          <path d="M37.8583 14.5833H22.9167C19.6015 14.5833 16.422 15.9003 14.0778 18.2445C11.7336 20.5887 10.4167 23.7681 10.4167 27.0833C10.4167 30.3985 11.7336 33.578 14.0778 35.9222C16.422 38.2664 19.6015 39.5833 22.9167 39.5833H41.6667V43.75H22.9167C18.4964 43.75 14.2572 41.9941 11.1316 38.8684C8.00595 35.7428 6.25 31.5036 6.25 27.0833C6.25 22.6631 8.00595 18.4238 11.1316 15.2982C14.2572 12.1726 18.4964 10.4167 22.9167 10.4167H37.8583L32.575 5.13333L35.5208 2.1875L45.8333 12.5L35.5208 22.8125L32.575 19.8667L37.8583 14.5833Z" fill="white"/>
                          <path d="M21.012 30.752C21.492 30.752 21.732 30.956 21.732 31.364C21.732 31.788 21.492 32 21.012 32H16.956C16.468 32 16.224 31.788 16.224 31.364C16.224 30.956 16.468 30.752 16.956 30.752H18.204V25.28L17.052 25.988C16.94 26.052 16.84 26.084 16.752 26.084C16.584 26.084 16.44 26.012 16.32 25.868C16.208 25.724 16.152 25.564 16.152 25.388C16.152 25.156 16.256 24.976 16.464 24.848L18.324 23.696C18.564 23.552 18.792 23.48 19.008 23.48C19.232 23.48 19.412 23.548 19.548 23.684C19.684 23.82 19.752 24.008 19.752 24.248V30.752H21.012ZM25.7953 32.108C24.7953 32.108 24.0313 31.74 23.5033 31.004C22.9753 30.26 22.7113 29.18 22.7113 27.764C22.7113 26.356 22.9753 25.284 23.5033 24.548C24.0313 23.804 24.7953 23.432 25.7953 23.432C26.7953 23.432 27.5593 23.804 28.0873 24.548C28.6153 25.284 28.8793 26.356 28.8793 27.764C28.8793 29.172 28.6153 30.248 28.0873 30.992C27.5593 31.736 26.7953 32.108 25.7953 32.108ZM25.7953 30.896C26.3393 30.896 26.7353 30.648 26.9833 30.152C27.2313 29.648 27.3553 28.852 27.3553 27.764C27.3553 26.668 27.2313 25.876 26.9833 25.388C26.7353 24.892 26.3393 24.644 25.7953 24.644C25.2513 24.644 24.8553 24.892 24.6073 25.388C24.3593 25.884 24.2353 26.676 24.2353 27.764C24.2353 28.852 24.3593 29.648 24.6073 30.152C24.8553 30.648 25.2513 30.896 25.7953 30.896Z" fill="white"/>
                          </svg>
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> 
    </Modal>
    </>
  )
}
